import { request } from '@/shared/api/request'

export const getStaffingGrants = ({params}) => {
	return request({ url: `staff/getGrants`, method: 'GET', params: params })
}